
export default () => {
    const siteHeaderEl = document.querySelector('.site-header');
    const headerNavEl = siteHeaderEl.querySelector('.site-header__nav');

    // Toggla menyn
    $('.site-header__nav-toggle').click(() => {
        document.body.classList.toggle('stop-scrolling');
        siteHeaderEl.classList.toggle('site-header--menu-open');

        const hidden = headerNavEl.getAttribute('aria-hidden');
        headerNavEl.setAttribute('aria-hidden', hidden === 'true' ? 'false' : 'true');
    });

    const getEmailAddress = () => {
        const links = document.querySelectorAll('a.tgr-load-email-address');

        if (links !== null && links.length > 0) {
            links.forEach((link) => {
                link.addEventListener('click', function(e) {
                    if (!link.getAttribute('data-email-loaded')) {
                        e.preventDefault();
                        link.textContent = 'Hämtar e-postadress..';

                        const data = {
                            action: 'matoratt_get_email_address',
                            ajax_nonce: horizon.ajaxNonce,
                            page_id: link.getAttribute('id'),
                            block_id: link.getAttribute('data-block-id'),
                        };
    
                        grecaptcha.ready(() => {
                            grecaptcha.execute('6LdniPgcAAAAABm6RqrzYNuWTDy5fNlJWRmdXbYF', {action: 'matoratt_validate_recaptcha'}).then((token) => {
                                data.recaptcha_token = token;
    
                                $.post({
                                    url: horizon.ajaxUrl,
                                    dataType: 'json',
                                    data,
                                    success(response) {
                                        if (response.hasOwnProperty('email')) {
                                            link.setAttribute('data-email-loaded', 'true');
                                            link.setAttribute('href', `mailto:${response.email}`);
                                            link.textContent = response.email;
                                        }
                                    }
                                });
                            });
                        });
                    }
                });
            });
        }
    };

    getEmailAddress();
};
